$.fn.absolutePositionInTable = function() {
    var $el;
    return this.each(function() {
      $el = $(this);

      var newDiv = $("<div />", {
        "class": "relative-inner",
        "css"  : {
          "height"  : $el.height(),
          "width"   : "100%",
          "position": "relative"
        }
      });
      $el.wrapInner(newDiv);
    });
};

$.fn.alignSponsors = function() {
    var $el, left, top;
    return this.each(function() {
      $el = $(this);

      left = 0 - Math.round($el.children('img').width() / 2);
      top = 0 - Math.round($el.children('img').height() / 2);

      $el
        .addClass('position')
        .children('img')
        .css({
          "margin-top" : top,
          "margin-left" : left
        });
    });
};

jQuery(document).ready(function($) {

  var announcementBlock = $('.announcement'),
      navbar = $('.navbar-main'),
      navbarWrapper = $('.navbar-wrapper'),
      navbarNavLinks = $('ul.navbar-nav'),
      navbarNavLinksWidth,
      navbarOffset,
      body = $('body');

  $('.panel-collapse').on('show.bs.collapse',function(){
      $(this).parent().addClass("active-panel");
  });

  $('.panel-collapse').on('hide.bs.collapse',function(){
      $(this).parent().removeClass("active-panel");
  });

  function resizeNavItems(){
    navbarWrapper.css('min-height', navbar.outerHeight());
  }

  body.scrollspy({ target: '.collapse.navbar-collapse', offset: 80 });

  $('.scrollto').click(function(e) {

    if($('.navbar-collapse.collapse').hasClass('in')){
      $(".navbar-toggle").click();
    }

    if(body.hasClass('index')){
      e.preventDefault();
      var target = '#' + $(this).data('scroll');
      $.scrollTo(target, 800, {
          'offset'  : -30,
          'axis'    :'y'
        });
    }
  });

  $('td.td-schedule-icon').absolutePositionInTable();

  var aboutMap, locationMap, infoWindow;
  var mapOptions = {
      center: new google.maps.LatLng(50.717215,-1.875472),
      zoom: 14,
      zoomControl: true,
      zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
      },
      disableDoubleClickZoom: true,
      mapTypeControl: true,
      mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      },
      scaleControl: false,
      scrollwheel: false,
      panControl: true,
      streetViewControl: false,
      draggable : false,
      overviewMapControl: false,
      overviewMapControlOptions: {
          opened: false,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          "stylers": [
            { "saturation": -100 },
            { "gamma": 0.8 },
            { "lightness": 4 }
          ]
        },{
          "featureType": "road.highway",
          "elementType": "labels.icon",
          "stylers": [
            { "visibility": "off" }
          ]
        }
      ],
  };

  function location_init() {
    var mapElement = document.getElementById("map-canvas");

    mapOptions.center = new google.maps.LatLng(50.715754,-1.877025);
    mapOptions.zoom = 15;

    locationMap = new google.maps.Map(mapElement, mapOptions);

    var locations = [
        ['Pavilion Dance South West', 'Main venue for redevelop', 50.717215,-1.875472, 'venue', 'https://goo.gl/maps/J24YZ'],
        ['Bournemouth Train Station', '', 50.727260,-1.864494, 'train', 'https://goo.gl/maps/6K8aj', ''],
        ['Bar So', 'Evening venue', 50.717578,-1.878987, 'party', 'https://goo.gl/maps/lgKFh', ''],
    ];

    infoWindow = new google.maps.InfoWindow({
      content: '<h4>Pavilion Dance South West</h4><p>Main venue for redevelop<br><a target="_blank" href="https://goo.gl/maps/J24YZ">Get directions</a></p><p></p>'
    });

    for (i = 0; i < locations.length; i++) {
      addMarker(locations[i], locationMap);
    }
  }

  function addMarker(location, map){

    var description;
    if (location[4] === 'hotel') {
      description = "<a target='_blank' href='" + location[6] + "'>Book a room</a>";
      description = description + "<br><a target='_blank' href='" + location[5] + "'>Get directions</a>";
    } else if(location[4] === 'train'){
      description = "<a target='_blank' href='" + location[5] + "'>Get directions</a>";
    } else {
      description = location[1] + "<br><a target='_blank' href='" + location[5] + "'>Get directions</a>";
    }

    var marker = new google.maps.Marker({
        icon: '/img/map/' + location[4] + '-marker.png',
        position: new google.maps.LatLng(location[2], location[3]),
        map: map,
        title: location[0],
        desc: description
    });

    google.maps.event.addListener(marker, 'click', function() {
      var html1 = '<div style="width:250px; min-height:70px;" class="info-window">';
      var html2 = "<h4>"+this.title+"</h4><p>"+this.desc+"<p>";
      var html3 = '</div>';
      infoWindow.setContent(html1 + html2 + html3);
      infoWindow.open(map,marker);
    });
  }

  resizeNavItems();
  $(window).resize(function(){
    resizeNavItems();
  });

  setTimeout(function() {
    resizeNavItems();
  }, 400);

  if($('#map-canvas').length > 0){
    location_init();
  }

  $('.talk-info_read-more').click(function(event) {
    event.preventDefault();
    $(this)
      .closest('.talk-info_small-description')
        .hide()
      .closest('.talk-info_description')
        .children('.talk-info_full-description').show();
  });

  var bLazy = new Blazy({
    offset: 300
  });

  if ($('.photo-wrap').length > 0) {
    $(".photo-wrap").justifiedGallery({
      rowHeight: 200
    });
  }

});
